import { useForm } from "react-hook-form";
import { SalesPromoModel } from "../../../models/SalesPromo.model";
import { useSafeFormDateRange } from "src/app/hooks/safe-form-date-range";
import { useEffect, useState } from 'react';
import { useSalesPromoDetailGeneralInfo, useSaveSalesPromoGeneral } from "../../../providers/SalesPromo.provider";

const defaultForm: SalesPromoModel = {
    category: 'SALES_PROMO',
    name: '',
    directory_ids: [],
    is_direct_cashback_point: undefined,
    cashback_type: undefined,
    cashback_type_select: undefined,
    earn_point: undefined,
    point_multiplication: undefined,
    max_earn_point: undefined,
    direct_gift_determination: undefined,
    is_mission_collect_stamp: undefined,
    prize_quantity_per_round: undefined,
    total_stamp_per_round: undefined,
    max_stamp_per_day: undefined,
    max_round_per_customer: undefined,
    stamp_name: '',
    stamp_icon: '',
    stamp_success: '',
    image: '',
    thumbnail_image: '',
    text_on_popup_eng: '',
    text_on_popup_idn: '',
    tnc_eng: '',
    tnc_idn: '',
    max_claim_per_day: undefined,
    max_claim_per_period: undefined,
    quota_type: undefined,
    total_quota: undefined,
    max_customer_per_day: undefined,
    is_unlimited_claim_per_day: false,
    is_unlimited_claim_per_period: false,
    is_unlimited_customer_per_day: false,
    is_unlimited_daily_quota_earned: false,
}

export function useSalesPromoForm1(id?: string) {
    const saveSalesPromoGeneral = useSaveSalesPromoGeneral()
    const salesPromoDetail = useSalesPromoDetailGeneralInfo(id, false)
    const form = useForm({ defaultValues: defaultForm, reValidateMode: 'onChange' })
    const masterCampaignType = [{
        value: 'MULTIPLICATION_POINT',
        label: 'Multiplication Point'
    },
    {
        value: 'EXTRA_POINT',
        label: 'Extra Point'
    }]

    const minPeriod = useSafeFormDateRange({
        startDateKey: 'start_date',
        endDateKey: 'end_date',
        form,
    })

    // Watch only the specific fields we care about
    const { name, directories, start_date, end_date, cashback_type_select, text_on_popup_eng, text_on_popup_idn } = form.watch();
    // Check if at least one of the required fields is filled
    const isFormFilled = name || start_date || end_date || directories || cashback_type_select || text_on_popup_eng || text_on_popup_idn
    const [salesPromoDetailStatus, setSalesPromoDetailStatus] = useState('')

    useEffect(() => {
        if (salesPromoDetail.data) {
            form.setValue('image', salesPromoDetail.data?.image);
            if (salesPromoDetail.data?.text_on_popup_eng !== undefined) {
                form.setValue('text_on_popup_eng', salesPromoDetail.data.text_on_popup_eng);
            }
            if (salesPromoDetail.data?.text_on_popup_idn !== undefined) {
                form.setValue('text_on_popup_idn', salesPromoDetail.data.text_on_popup_idn);
            }
            setSalesPromoDetailStatus(salesPromoDetail.data?.status);
        }
    }, [salesPromoDetail.data])

    const enabledFields = () => {
        const fields = [
            'end_date',
            'image',
            'text_on_popup_eng',
            'text_on_popup_idn',
            'tnc_eng',
            'tnc_idn',
            'is_draft',
            'max_claim_per_day',
            'quota_type',
            'total_quota',
            'max_daily_quota_earned',
            'max_customer_per_day'
        ]

        if (salesPromoDetailStatus === 'ACTIVE') {
            return fields;
        }
        return [
            ...fields, 
            'cashback_type', 
            'name', 
            'directory_ids', 
            'directories', 
            'start_date', 
            'cashback_type_select', 
            'point_multiplication', 
            'max_earn_point', 
            'earn_point', 
            'max_claim_per_period',
            'is_direct_cashback_point',
            'direct_gift_determination',
            'is_mission_collect_stamp',
            'prize_quantity_per_round',
            'total_stamp_per_round',
            'max_stamp_per_day',
            'max_round_per_customer',
            'stamp_name',
            'stamp_icon',
            'stamp_success'
        ]
    }

    return ({
        saveSalesPromoGeneral,
        salesPromoDetail,
        salesPromoDetailStatus,
        form,
        masterCampaignType,
        minPeriod,
        isFormFilled,
        enabledFields
    })
}